var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('WelcomeBackDialog'),_c('v-main',{style:({ backgroundColor: _vm.$vuetify.theme.dark ? '#111' : '#EA532E' })},[_c('MenuDrawer'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer'),_c('NavBar',{on:{"font-size-changed":_vm.updateFontSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }